import React from "react";
import { Link } from "react-router-dom";
import JsonData from "../data/data.json";

const integrations = JsonData.Integrations;

const PageFooter = () => (
  <div id="footer">
    <div className="container text-center">
      <p>
        &copy; 2026 ByTheApp. All rights reserved.{" "}
        <a href="mailto:info@bytheapp.com">info@bytheapp.com</a>
        {" · "}
        <Link to="/blog">Blog</Link>
        {" · "}
        <Link to="/integrations">Integrations</Link>
        {" · "}
        <Link to="/privacy">Privacy Policy</Link>
        {" · "}
        <Link to="/terms">Terms</Link>
      </p>
    </div>
  </div>
);

const Integrations = () => {
  return (
    <div className="integrations-page">
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#integrations-nav-collapse"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <Link className="navbar-brand" to="/">
              By The App
            </Link>
          </div>
          <div className="collapse navbar-collapse" id="integrations-nav-collapse">
            <ul className="nav navbar-nav navbar-right">
              <li>
                <Link to="/#products">Products</Link>
              </li>
              <li>
                <Link to="/#about">About</Link>
              </li>
              <li>
                <Link to="/integrations">Integrations</Link>
              </li>
              <li>
                <Link to="/#pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/#contact">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <section className="integrations-hero">
        <div className="container">
          <span className="integrations-eyebrow">{integrations.eyebrow}</span>
          <h1 className="integrations-title">{integrations.title}</h1>
          <p className="integrations-lead">{integrations.lead}</p>
        </div>
      </section>

      <section className="integrations-grid-section">
        <div className="container">
          <div className="integrations-grid">
            {integrations.items.map((item) => (
              <article
                key={item.name}
                className="integration-card"
                style={{ "--integration-accent": item.color }}
              >
                <div className="integration-card-header">
                  <span className="integration-logo" aria-hidden="true">
                    {item.name.charAt(0)}
                  </span>
                  <div>
                    <span className="integration-category">{item.category}</span>
                    <h2 className="integration-name">{item.name}</h2>
                  </div>
                </div>
                <p className="integration-description">{item.description}</p>
                <ul className="integration-capabilities">
                  {item.capabilities.map((cap) => (
                    <li key={cap}>{cap}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="integrations-platform">
        <div className="container">
          <div className="integrations-platform-inner">
            <div className="integrations-platform-copy">
              <span className="integrations-eyebrow integrations-eyebrow-light">
                Platform
              </span>
              <h2>{integrations.platformTitle}</h2>
              <p>{integrations.platformLead}</p>
            </div>
            <div className="integrations-hub" aria-hidden="true">
              <div className="integrations-hub-center">ByTheApp</div>
              <div className="integrations-hub-orbit">
                {integrations.items.map((item, i) => (
                  <span
                    key={item.name}
                    className="integrations-hub-node"
                    style={{
                      "--i": i,
                      "--total": integrations.items.length,
                      "--accent": item.color,
                    }}
                  >
                    {item.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="integrations-flow">
        <div className="container">
          <span className="integrations-eyebrow">How it works</span>
          <h2 className="integrations-flow-title">End-to-end in one conversation</h2>
          <div className="integrations-flow-steps">
            {integrations.flowSteps.map((step) => (
              <div key={step.step} className="integrations-flow-step">
                <span className="integrations-flow-number">{step.step}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="integrations-cta">
        <div className="container">
          <h2>{integrations.ctaTitle}</h2>
          <p>{integrations.ctaLead}</p>
          <Link to="/#contact" className="btn btn-custom btn-lg">
            {integrations.ctaButton}
          </Link>
        </div>
      </section>

      <PageFooter />
    </div>
  );
};

export default Integrations;
